// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { useRef, useEffect, useState } from "react";
// import styles from "../PieChart.module.scss";
// import JobCategoryChartFilter from "./JobCategoryChartFilter";
// import { GetJobsDashboard } from "../../../apiServices";
// import { useSelector } from "react-redux";
// import { colorPalette } from "../../../utility";

// const JobDoughnutChart = ({ width = 800, height = 400 }) => {
//   const JobsFilter = useSelector(
//     (state) => state.JobsDashboardFilterDetails.JobsDashboard
//   );
//   const [jobCountData, setJobCountData] = useState([]);
//   const [tooltip, setTooltip] = useState({
//     visible: false,
//     label: "",
//     value: 0,
//     x: 0,
//     y: 0,
//   });

//   const canvasRef = useRef(null);
//   useEffect(() => {
//     GetJobsDashboard(JobsFilter).then((data) => {
//       if (data.message === "No jobs found.") {
//         setJobCountData();
//       }
//       setJobCountData(data.jobCounts);
//       // console.log(data.jobCounts, "dashboard");
//     });
//   }, [JobsFilter]);

//   const totalOpenings = jobCountData.reduce(
//     (sum, item) => sum + parseInt(item.no_of_openings, 10),
//     0
//   );

//   const legendData = jobCountData.map((item) => {
//     const count = parseInt(item.no_of_openings, 10);
//     const percentage = (count / totalOpenings) * 100;
//     return { label: item.job_category, value: count, percentage };
//   });

//   // Prepare legend data with categories below 10% grouped into "Others"
// const data = legendData.reduce((acc, item) => {
//   if (item.percentage < 2) {
//     // Add item to "Others" if its percentage is below 10%
//     const others = acc.find((i) => i.label === "Others");
//     if (others) {
//       others.value += item.value;
//     } else {
//       acc.push({ label: "Others", value: item.value });
//     }
//   } else {
//     acc.push({ label: item.label, value: item.value });
//   }
//   return acc;
// }, []);

// // Render data with no.of.vacancy only (value)
// data.forEach((item) => {
//   console.log(`Category: ${item.label}, Openings: ${item.value}`);
// });

//   const total = data.reduce((acc, item) => acc + item.value, 0);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     const radius = Math.min(width, height) / 2.5;
//     const innerRadius = radius * 0.6;
//     const centerX = width / 2;
//     const centerY = height / 2;
//     let startAngle = -Math.PI / 2;

//     // Clear canvas
//     ctx.clearRect(0, 0, width, height);

//     if (data.length === 0) {
//       // No data scenario: Draw a single colored circle
//       ctx.beginPath();
//       ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
//       ctx.fillStyle = "#cccccc";
//       ctx.fill();

//       // Add "No data" text in the center
//       ctx.font = "20px Arial";
//       ctx.fillStyle = "#000";
//       ctx.textAlign = "center";
//       ctx.textBaseline = "middle";
//       ctx.fillText("No data", centerX, centerY);
//     } else {
//       // Draw chart segments
//       data.forEach((item, index) => {
//         const sliceAngle = (item.value / total) * 2 * Math.PI;
//         const endAngle = startAngle + sliceAngle;

//         // Draw each segment
//         ctx.beginPath();
//         ctx.arc(centerX, centerY, radius, startAngle, endAngle);
//         ctx.lineTo(centerX, centerY);
//         ctx.fillStyle = colorPalette[index % colorPalette.length];
//         ctx.fill();

//         // Skip drawing label for "Others"
//         if (item.label === "Others") {
//           const midAngle = startAngle + sliceAngle / 2;
//           const othersLabelX = centerX + Math.cos(midAngle) * (radius + 30);
//           const othersLabelY = centerY + Math.sin(midAngle) * (radius + 30);

//           // Draw line from segment to label with corner style for "Others"
//           const lineEndX = centerX + Math.cos(midAngle) * radius;
//           const lineEndY = centerY + Math.sin(midAngle) * radius;

//           ctx.beginPath();
//           ctx.moveTo(lineEndX, lineEndY);
//           const cornerX =
//             othersLabelX > centerX ? lineEndX + 10 : lineEndX - 10;
//           ctx.lineTo(cornerX, lineEndY);
//           ctx.lineTo(othersLabelX, othersLabelY);
//           ctx.strokeStyle = colorPalette[index % colorPalette.length];
//           ctx.lineWidth = 2;
//           ctx.stroke();

//           // Draw label text for "Others"
//           ctx.font = "12px Arial";
//           ctx.fillStyle = "#000";
//           ctx.textAlign = othersLabelX > centerX ? "right" : "left";
//           ctx.fillText("Others", othersLabelX, othersLabelY);
//         } else {
//           // Calculate mid angle for label positioning
//           const midAngle = startAngle + sliceAngle / 2;
//           const labelX = centerX + Math.cos(midAngle) * (radius + 40);
//           const labelY = centerY + Math.sin(midAngle) * (radius + 35);
//           const lineEndX = centerX + Math.cos(midAngle) * radius;
//           const lineEndY = centerY + Math.sin(midAngle) * radius;

//           // Draw line from segment to label with corner style
//           ctx.beginPath();
//           ctx.moveTo(lineEndX, lineEndY);
//           const cornerX = labelX > centerX ? lineEndX + 10 : lineEndX - 15;
//           ctx.lineTo(cornerX, lineEndY);
//           ctx.lineTo(labelX, labelY);
//           ctx.strokeStyle = colorPalette[index % colorPalette.length];
//           ctx.lineWidth = 2;
//           ctx.stroke();

//           // Draw label text
//           ctx.font = "12px Arial";
//           ctx.fillStyle = "#000";
//           ctx.textAlign = labelX > centerX ? "left" : "right";

//           if (item.label.length > 18) {
//             const firstLine = item.label.substring(0, 18);
//             const secondLine = item.label.substring(18);

//             ctx.fillText(firstLine, labelX, labelY);
//             ctx.fillText(secondLine, labelX, labelY + 15);
//           } else {
//             ctx.fillText(item.label, labelX, labelY);
//           }
//         }

//         startAngle = endAngle;
//       });
//     }

//     // Draw inner circle to make doughnut shape
//     ctx.beginPath();
//     ctx.arc(centerX, centerY, innerRadius, 0, 2 * Math.PI);
//     ctx.fillStyle = "#ffffff";
//     ctx.fill();
//   }, [data, total, width, height, colorPalette]);
//   const handleMouseMove = (event) => {
//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext("2d");
//     const rect = canvas.getBoundingClientRect();
//     const mouseX = event.clientX - rect.left;
//     const mouseY = event.clientY - rect.top;
//     const centerX = width / 2;
//     const centerY = height / 2;
//     const radius = Math.min(width, height) / 2.5;
//     const innerRadius = radius * 0.6;

//     // Calculate distance from center
//     const dx = mouseX - centerX;
//     const dy = mouseY - centerY;
//     const distance = Math.sqrt(dx * dx + dy * dy);

//     // Check if within doughnut radius
//     if (distance < radius && distance > innerRadius) {
//       // Calculate angle
//       let angle = Math.atan2(dy, dx);
//       if (angle < -Math.PI / 2) angle += 2 * Math.PI;

//       // Find the hovered segment
//       let startAngle = -Math.PI / 2;
//       for (let i = 0; i < data.length; i++) {
//         const item = data[i];
//         const sliceAngle = (item.value / total) * 2 * Math.PI;
//         const endAngle = startAngle + sliceAngle;

//         if (angle >= startAngle && angle <= endAngle) {
//           // Show tooltip
//           setTooltip({
//             visible: true,
//             label: item.label,
//             value: item.value,
//             x: mouseX,
//             y: mouseY,
//           });
//           return;
//         }
//         startAngle = endAngle;
//       }
//     } else {
//       setTooltip({ visible: false, label: "", value: 0, x: 0, y: 0 });
//     }
//   };
//   return (
//     <>
//       <div className="container-fluid">
//         <div className="d-flex align-items-center justify-content-between">
//           <div className={` mt-2 ${styles.heading}`}>
//             <h6>Number of Vacancies by Job Category</h6>
//           </div>
//           <div>
//             <JobCategoryChartFilter />
//           </div>
//         </div>
//         <div className="">
//           <div className={`row  ${styles.container}`}>
//             <div
//               className={`col-sm-8 ${styles.chartContainer}`}
//               onMouseMove={handleMouseMove}
//             >
//               <canvas ref={canvasRef} width={width} height={height} />

//               {tooltip.visible && (
//                 <div
//                   className={styles.tooltip}
//                   style={{ left: tooltip.x + 10, top: tooltip.y + 10 }}
//                 >
//                   <strong>{tooltip.label}</strong>: {tooltip.value}
//                 </div>
//               )}
//             </div>
//             <div
//               className={`col-sm-4 d-inline-flex align-items-center justify-conent-center`}
//             >
//               <div className={`w-75 ${styles.legend}`}>
//                 {legendData.length > 0 ? (
//                   legendData.map((item, index) => (
//                     <div key={index} className={styles.legendItem}>
//                       <span
//                         className={styles.legendColor}
//                         style={{
//                           backgroundColor:
//                             colorPalette[index % colorPalette.length],
//                         }}
//                       ></span>
//                       <span className={styles.legendText}>{item.label}</span>
//                       <span className={styles.legendValue}>{item.value}</span>
//                     </div>
//                   ))
//                 ) : (
//                   <div className={styles.noDataMessage}>No data available</div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default JobDoughnutChart;

import React, { useEffect, useRef, useState } from "react";
import { Chart, registerables } from "chart.js";
import JobCategoryChartFilter from "./JobCategoryChartFilter";
import styles from "../PieChart.module.scss";
import { GetJobsDashboard } from "../../../apiServices";
import { useSelector } from "react-redux";
import {
  capitalizeWord,
  colorPalette,
  Ddmmmyyyy_date,
  DMMMYYYY_formate,
} from "../../../utility";

// Register the necessary components from Chart.js
Chart.register(...registerables);

const JobDoughnutChart = () => {
  const chartRef = useRef(null);
  const JobsFilter = useSelector(
    (state) => state.JobsDashboardFilterDetails.JobsDashboard
  );
  const [jobCountData, setJobCountData] = useState([]);
  const [FilterApplied, setFilterApplied] = useState({
    companyName: "",
    startDate: "",
    city: "",
    endDate: "",
  });

  // Fetch job count data
  useEffect(() => {
    GetJobsDashboard(JobsFilter).then((data) => {
      if (data.message === "No jobs found.") {
        setJobCountData([]);
        setFilterApplied((pre) => ({
          ...pre,
          companyName: data.filtersApplied.companyName,
          city: data.filtersApplied.jobCity,
          startDate: data.filtersApplied.startDate,
          endDate: data.filtersApplied.endDate,
        }));
      } else {
        setJobCountData(data.jobCounts);
        const FilterData = data;
        console.log(FilterData.filtersApplied, "FilterData");

        setFilterApplied((pre) => ({
          ...pre,
          companyName: data.filtersApplied.companyName,
          city: data.filtersApplied.jobCity,
          startDate: data.filtersApplied.startDate,
          endDate: data.filtersApplied.endDate,
        }));
      }
    });
  }, [JobsFilter]);

  const totalOpenings = jobCountData.reduce(
    (sum, item) => sum + parseInt(item.no_of_openings, 10),
    0
  );

  // Group categories with counts below 5% into "Others"
  const groupedData = jobCountData.reduce((acc, item) => {
    const openings = parseInt(item.no_of_openings, 10);
    const percentage = (openings / totalOpenings) * 100;

    if (percentage < 2) {
      if (!acc.others) {
        acc.others = { job_category: "Others Category", no_of_openings: 0 };
      }
      acc.others.no_of_openings += openings;
    } else {
      acc[item.job_category] = item;
    }
    return acc;
  }, {});

  // Prepare the final dataset with "Others"
  const finalJobData = Object.values(groupedData);

  // Define the legend data excluding "Others"
  const legendData = jobCountData
    .filter((item) => item.job_category !== "Others Category")
    .map((item) => {
      const count = parseInt(item.no_of_openings, 10);
      const percentage = (count / totalOpenings) * 100;
      return { label: item.job_category, value: count, percentage };
    });

  // Define the custom plugin for drawing arrows and labels
  const drawArrowsPlugin = {
    id: "drawArrows",
    afterDatasetsDraw(chart, args, options) {
      const {
        ctx,
        chartArea: { left, right, top, bottom },
      } = chart;

      const metaSet = chart._metasets[0];
      if (!metaSet || !metaSet.data[0]) return;

      const radius = metaSet.data[0].outerRadius;
      const centerX = (left + right) / 2;
      const centerY = (top + bottom) / 2;

      chart.data.labels.forEach((label, index) => {
        const arc = chart.getDatasetMeta(0).data[index];
        const angle = (arc.startAngle + arc.endAngle) / 2;

        const startX = centerX + Math.cos(angle) * (radius * 0.7);
        const startY = centerY + Math.sin(angle) * (radius * 0.8);
        const endX = centerX + Math.cos(angle) * (radius * 1.1);
        const endY = centerY + Math.sin(angle) * (radius * 1.05);

        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        ctx.strokeStyle = arc.options.backgroundColor;
        ctx.lineWidth = 2;
        ctx.stroke();

        const arrowSize = 6;
        ctx.beginPath();
        ctx.moveTo(endX, endY);
        ctx.lineTo(
          endX - arrowSize * Math.cos(angle - Math.PI / 6),
          endY - arrowSize * Math.sin(angle - Math.PI / 6)
        );
        ctx.lineTo(
          endX - arrowSize * Math.cos(angle + Math.PI / 6),
          endY - arrowSize * Math.sin(angle + Math.PI / 6)
        );
        ctx.lineTo(endX, endY);
        ctx.fillStyle = arc.options.backgroundColor;
        ctx.fill();

        const wrapText = (text, maxLength) => {
          const words = text.split(" ");
          let line = "";
          const lines = [];

          words.forEach((word) => {
            if ((line + word).length > maxLength) {
              lines.push(line);
              line = word;
            } else {
              line += (line.length > 0 ? " " : "") + word;
            }
          });

          lines.push(line);
          return lines;
        };

        const labelX = endX + (endX < centerX ? -100 : 5);
        const labelY = endY;
        const wrappedText = wrapText(label, 18);

        ctx.font = "12px Arial";
        ctx.fillStyle = "#333";
        wrappedText.forEach((line, i) => {
          ctx.fillText(line, labelX, labelY + i * 12);
        });
      });
    },
  };

  useEffect(() => {
    Chart.register(drawArrowsPlugin);

    const ctx = chartRef.current.getContext("2d");
    const myDonutChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: finalJobData.map((item) => item.job_category),
        datasets: [
          {
            label: "Job Categories",
            data: finalJobData.map((item) => parseInt(item.no_of_openings, 10)),
            backgroundColor: [
              ...colorPalette,
              ...(finalJobData.some(
                (item) => item.job_category === "Others Category"
              )
                ? ["#f0f0f0"]
                : []),
            ],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        responsive: true,
        layout: {
          padding: 20,
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            color: "",
            font: {
              weight: "bold",
              size: 12,
            },
            zindex: 2,
          },
          tooltip: {
            callbacks: {
              label: function (tooltipItem) {
                return tooltipItem.label + ": " + tooltipItem.raw;
              },
            },
          },
        },
        cutout: "60%",
      },
    });

    return () => {
      myDonutChart.destroy();
      Chart.unregister(drawArrowsPlugin);
    };
  }, [finalJobData]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className={`${styles.heading}`}>
          <h6>Number of Vacancies by Job Category</h6>
        </div>
        <div>
          <JobCategoryChartFilter />
        </div>
      </div>
      <div className="container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          className="row"
        >
          <div className="col">
            <canvas
              id="myDonutChart"
              ref={chartRef}
              style={{ width: "100%", maxWidth: "700px", maxHeight: "400px" }}
            ></canvas>
            <div className="text-center mt-3">
              <span>
                <b>
                  <DMMMYYYY_formate dateValue={FilterApplied.startDate} />{" "}
                </b>{" "}
                to{" "}
                <b>
                  <DMMMYYYY_formate dateValue={FilterApplied.endDate} />
                </b>
              </span>
            </div>
          </div>
          <div className="col">
            <div className="d-flex align-items-center justify-content-between text-center">
              <span>
                {FilterApplied.companyName != null ? (
                  <>
                    Company Name:{" "}
                    <b>{capitalizeWord(FilterApplied.companyName)}</b>
                  </>
                ) : (
                  ""
                )}
              </span>
              <span>
                {FilterApplied.city != null ? (
                  <>
                    City : <b>{capitalizeWord(FilterApplied.city)}</b>
                  </>
                ) : (
                  ""
                )}
              </span>
            </div>
            <div className={`${styles.legend}`}>
              {legendData.length > 0 ? (
                legendData.map((item, index) => (
                  <div key={index} className={styles.legendItem}>
                    <span
                      className={styles.legendColor}
                      style={{
                        backgroundColor:
                          colorPalette[index % colorPalette.length],
                      }}
                    ></span>

                    <span className={styles.legendText}>{item.label}</span>
                    <span className={styles.legendValue}>{item.value}</span>
                  </div>
                ))
              ) : (
                <div className={styles.noDataMessage}>No data available</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobDoughnutChart;
